
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurants/[id]/[slug]",
      function () {
        return require("private-next-pages/restaurants/[id]/[slug].tsx");
      }
    ]);
  